import type { StartPage as StandardHeadlessPage } from '@/@types/content';
import withNav from '../hocs/withNav';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';

type StandardHeadlessPageProps = StandardHeadlessPage & {
  isPLIEmployee?: boolean;
};

const StandardHeadlessPageComponent: React.FC<StandardHeadlessPageProps> = props => {
  const navigate = useNavigate();

  useEffect(() => {
    if ((props.isPLIEmployee as boolean) !== true) navigate('/');
  }, [navigate, props.isPLIEmployee]);

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex" />
      </Helmet>
      {props.isPLIEmployee ? (
        <pre className="container">{JSON.stringify(props, null, 2)}</pre>
      ) : (
        <></>
      )}
    </>
  );
};

const StandardHeadlessPage = withNav(StandardHeadlessPageComponent);
export default StandardHeadlessPage;
